import { render } from "./OmniSearchButtonIcon.vue?vue&type=template&id=292219ac&scoped=true&ts=true"
import script from "./OmniSearchButtonIcon.ts?vue&type=script&lang=ts&external"
export * from "./OmniSearchButtonIcon.ts?vue&type=script&lang=ts&external"

import "./OmniSearchButtonIcon.scss?vue&type=style&index=0&id=292219ac&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-292219ac"]])

export default __exports__